import { render, staticRenderFns } from "./index.vue?vue&type=template&id=866b301e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TherapistSearch: require('/data/www/nvpa.org/nvpa/nuxt/components/therapist/Search.vue').default,GeneralTour: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Tour.vue').default,NewsItem: require('/data/www/nvpa.org/nvpa/nuxt/components/news/Item.vue').default,ActivitiesCalendarList: require('/data/www/nvpa.org/nvpa/nuxt/components/activities/CalendarList.vue').default,GeneralPaymentPopup: require('/data/www/nvpa.org/nvpa/nuxt/components/general/PaymentPopup.vue').default,HomePopup: require('/data/www/nvpa.org/nvpa/nuxt/components/home/Popup.vue').default})
